import _ from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { useUser } from '@/providers';
import {
  Box,
  Container,
  Typography,
  Paper,
  CircularProgress,
  Alert,
  Grid,
} from '@mui/material';

import PaymentMethodList from './method/PaymentMethodList';
import PaymentForm from './PaymentForm';
import ConsolidatedBillingForm from './ConsolidatedBillingForm';

const PersonalBilling = () => {
  const user = useUser();
  const paymentMethods = useSelector((state) => state.paymentMethods);
  const primaryPaymentMethod = _.filter(paymentMethods, (method) => {
    return method.id === user.primary_pm;
  })[0];

  const renderPaymentForm = () => {
    if (!paymentMethods) {
      return (
        <Paper sx={{ position: 'relative', p: 3 }}>
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'rgba(255, 255, 255, 0.7)',
            }}
          >
            <CircularProgress />
          </Box>
          <Box sx={{ height: 200 }} />
        </Paper>
      );
    }

    if (paymentMethods.length > 0) {
      return (
        <PaymentForm user={user} primaryPaymentMethod={primaryPaymentMethod} />
      );
    }

    return (
      <Alert severity='error'>
        Please add a payment method to purchase credits.
      </Alert>
    );
  };

  return (
    <Container>
      <Grid container spacing={3}>
        <Grid size={12}>{renderPaymentForm()}</Grid>
        <Grid size={12}>
          <Paper sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant='h4' component='h2' gutterBottom>
              Payment Methods
            </Typography>
            <PaymentMethodList primary={user.primary_pm} />
          </Paper>
        </Grid>
        <Grid size={12}>
          <ConsolidatedBillingForm />
        </Grid>
      </Grid>
    </Container>
  );
};

export default PersonalBilling;
